<template>
  <div class="content my-bonus-info">
    <h3>{{ $t('Bao.event-me') }}</h3>
    <div class="bonus-count">
      <ul>
        <li> {{ $t("Bao.total_bonus_amount") }}</li>
        <li> {{ prize.total | numberFormat }}</li>
        <li>100%</li>
      </ul>
      <ul>
        <li> {{ $t("Bao.received") }}</li>
        <li class="highlight">
          {{ prize.received | numberFormat }}
        </li>
        <li class="highlight">
          {{ percent }}%
        </li>
      </ul>
      <div class="percent">
        <i :style="{ width: percent + '%' }" />
      </div>
    </div>
    <div class="tabs-mobile" @click="clickToogleAccountQuick()">
      <span>{{ currentTaskName }}<i /></span>
    </div>
    <!-- 電腦版 -->
    <div class="bonus-list">
      <ul ref="checkDeposit" class="bonus-list-menu">
        <li
          v-for="(item, key) in task"
          :key="key"
          :class="{ active: isActive(item, key) }"
          @click="goTask(item.id)"
        >
          <a>
            {{ item.name }}
          </a>
        </li>
      </ul>

      <div v-for="(parent_item, index) in selectTask" :key="index" class="bonus-list-content">
        <div v-if="parent_item.list.length === 0" class="no-data">
          <i><img :src="require(`@/assets/${$store.getters.currentTheme}/images/no-data.png`)" alt=""></i>
          <p>{{ $t('Bao.no_relevant_data_records') }}</p>
          <span>{{ $t('Bao.search_results_are_empty') }}</span>
        </div>

        <div
          v-for="(item, key2) in parent_item.list"
          v-else
          :key="'parent_item' + key2"
          class="bonus-item"
        >
          <p>
            <span>{{ item.event_text }}
              <template v-if="parent_item.type !== 'friend'">
                ({{
                  item.progress.current_value +
                    "/" +
                    item.progress.condition_value
                }})
              </template>
            </span>
            <span>  {{ item.sub_text }}</span>
          </p>
          <button
            :class="labelClasses(item.status)"
            :disabled="getEventReceive(item.status)"
            @click="clickReceive(item)"
          >
            {{ item.status_text }}
          </button>
        </div>
      </div>
    </div>
    <!-- 手機版 -->
    <div class="tabs-mobile-list" :class="{ active: tabsMobileActive }">
      <div class="tabs-mobile-header" @click="closeAccountQuick()">
        <span>Done</span>
      </div>
      <ul ref="checkDeposit">
        <li v-for="(item, key) in task" :key="key">
          <a @click="goTask(item.id)">
            {{ item.name }}
          </a>
        </li>
      </ul>
    </div>
    <div v-for="(parent_item, index) in selectTask" :key="index" class="bonus-list-mobile">
      <div v-if="parent_item.list.length === 0" class="no-data">
        <i><img :src="require(`@/assets/${$store.getters.currentTheme}/images/no-data.png`)" alt=""></i>
        <p>{{ $t('Bao.no_relevant_data_records') }}</p>
        <span>{{ $t('Bao.search_results_are_empty') }}</span>
      </div>
      <div v-for="(item, key2) in parent_item.list" v-else :key="'parent_item' + key2" class="bonus-item">
        <p>
          <span>{{ item.event_text }}
            <template v-if="parent_item.type !== 'friend'">
              ({{
                item.progress.current_value +
                  "/" +
                  item.progress.condition_value
              }})
            </template>
          </span>
          <span>{{ item.sub_text }}</span>
        </p>
        <div class="button-wrap">
          <button
            :class="labelClasses(item.status)"
            :disabled="getEventReceive(item.status)"
            @click="clickReceive(item)"
          >
            {{ item.status_text }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getEventTask, getMemberTask, receive } from '@/api/event'
import { showNotice } from '@/utils/tool'

export default {
  data() {
    return {
      task: [],
      allTask: [],
      selectTask: [],
      prize: {
        total: 0,
        received: 0
      },
      percent: 0,
      taskId: false,
      isLoaded: false,
      actionLoading: false,
      currentTaskName: null,
      noData: false,
      tabsMobileActive: false
    }
  },
  watch: {
    '$route.params.task_id': function(to) {
      const elem = this.$refs.checkDeposit
      elem.click()
      if (to === undefined) {
        this.taskId = false
        this.filterTask()
        return
      }
      this.taskId = parseInt(to)
      this.currentTaskName = this.findTaskName()
      this.filterTask()
    }
  },
  created() {
    if (this.$route.params.task_id !== undefined) {
      this.taskId = parseInt(this.$route.params.task_id)
    }
    this.query()
  },
  methods: {
    query() {
      getEventTask()
        .then((response) => {
          this.task = response.data.data.list
          if (this.task.length === 0) {
            this.isLoaded = true
            this.noData = true
            return
          }
          this.currentTaskName = this.findTaskName()
          this.queryAllMemberTask()
        })
        .catch((error) => {
          showNotice(error.response.data.msg)
        })
    },
    queryAllMemberTask() {
      this.prize.total = 0
      this.prize.received = 0
      this.allTask = {}
      this.selectTask = {}
      for (const i in this.task) {
        getMemberTask({ event_id: this.task[i].id }).then((response) => {
          const obj = response.data.data
          obj.task_id = this.task[i].id
          this.allTask[obj.task_id] = obj

          obj.type = this.task[i].type

          if (!this.taskId && i === '0') { // Check if it's the first task instead of the second
            this.selectTask[obj.task_id] = obj
            this.updatePrizeData(obj)
          } else if (this.taskId && this.task[i].id === this.taskId) {
            this.$set(this.selectTask, obj.task_id, obj)
            this.updatePrizeData(obj)
          }

          this.isLoaded = true
        })
      }
    },
    updatePrizeData(obj) {
      this.prize.total += obj.prize.total
      this.prize.received += obj.prize.received
      this.percent = this.getPercent(this.prize.received, this.prize.total)
    },
    filterTask() {
      this.selectTask = {}
      this.prize.total = 0
      this.prize.received = 0
      for (const i in this.allTask) {
        if (!this.taskId) {
          this.selectTask[i] = this.allTask[i]
        } else {
          if (this.taskId === this.allTask[i].task_id) {
            this.selectTask[i] = this.allTask[i]
          }
        }
      }
      for (const i in this.selectTask) {
        this.prize.total += this.selectTask[i].prize.total
        this.prize.received += this.selectTask[i].prize.received
        this.percent = this.getPercent(this.prize.received, this.prize.total)
      }
    },
    clickReceive(item) {
      if (this.actionLoading) {
        return
      }
      if (item.status !== 2) {
        return
      }

      this.actionLoading = item.event_member_id
      receive(item.event_member_id)
        .then((response) => {
          showNotice(response.data.msg)
          this.queryAllMemberTask()
        })
        .catch((error) => {
          showNotice(error.response.data.msg)
        })
        .finally((e) => {
          this.actionLoading = false
        })
    },
    labelClasses(status) {
      const classArr = []
      if (status === 0) classArr.push('bonus-item-button-2')
      // 進行中/未完成
      else if (status === 1) classArr.push('bonus-item-button-4')
      // 審核中
      else if (status === 2) classArr.push('bonus-item-button-3')
      // 已放款/未領取
      else if (status === 3) classArr.push('bonus-item-button-1')
      // 已領取
      return classArr
    },
    getEventReceive(status) {
      // 若 審核中,則 disabled
      if (status === 0 || status === 1 || status === 3) {
        return true
      }
      return false
    },
    findTaskName() {
      if (!this.taskId) return this.task[0].name
      for (const i in this.task) {
        if (this.task[i].id === this.taskId) {
          return this.task[i].name
        }
      }
      return 'not found'
    },
    goTask(taskId) {
      this.closeAccountQuick()
      if (this.$router.currentRoute.path.indexOf('/web') >= 0) {
        this.$router.push('/web/event/me/' + (taskId || '')).catch(() => {})
      } else {
        this.$router.push('/user/event/me/' + (taskId || '')).catch(() => {})
      }
    },
    getPercent(num1, num2) {
      if (num1 === 0 && num2 === 0) {
        return 0
      } else {
        return ((num1 / num2) * 100).toFixed(0)
      }
    },
    clickToogleAccountQuick() {
      this.tabsMobileActive = !this.tabsMobileActive
      this.$store.state.app.hideMobileNav = !this.$store.state.app.hideMobileNav
    },
    closeAccountQuick() {
      this.tabsMobileActive = false
      this.$store.state.app.hideMobileNav = false
    },
    isActive(item, index) {
      if (!this.taskId && index === 0) return true // For the first item when taskId is not set
      return this.taskId === item.id // For other items
    }
  }
}
</script>
